import React, { useEffect, useRef, useState } from 'react';
import { Modal, message } from 'antd';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { getRequestErrorMessage } from '@/utils/requestError';
import './index.scss';

const ConfirmAction = ({ children, title, onConfirm, disabled = false }) => {
  const [open, setOpen] = useState(false);
  const [pending, setPending] = useState(false);
  const locked = useRef(false);
  const alive = useRef(false);
  useEffect(() => { alive.current = true; return () => { alive.current = false; }; }, []);
  const confirm = async () => {
    if (disabled || locked.current || !open) return;
    locked.current = true;
    setPending(true);
    try {
      const result = await onConfirm();
      if (alive.current && result !== false) setOpen(false);
    } catch (error) {
      if (alive.current) message.error(getRequestErrorMessage(error, '操作失败，请重试'));
    } finally {
      locked.current = false;
      if (alive.current) setPending(false);
    }
  };
  return <>
    {React.cloneElement(children, {
      disabled: disabled || children.props.disabled || pending,
      'aria-haspopup': 'dialog',
      onClick: event => {
        if (disabled || children.props.disabled || locked.current) return;
        children.props.onClick?.(event);
        if (!event.defaultPrevented) setOpen(true);
      },
    })}
    <Modal className="confirm-action-modal" title="操作确认" centered width={420} open={open}
      okText="确定" cancelText="取消" confirmLoading={pending}
      okButtonProps={{ danger: Boolean(children.props.danger), disabled: disabled || pending }}
      cancelButtonProps={{ disabled: pending }} closable={!pending} keyboard={!pending} mask={{ closable: !pending }}
      onOk={confirm} onCancel={() => { if (!locked.current) setOpen(false); }}>
      <div className="confirm-action-content"><ExclamationCircleFilled aria-hidden="true" /><p>{title}</p></div>
    </Modal>
  </>;
};

export default ConfirmAction;
